package dev.lingvo.site.api

import dev.lingvo.shared.ActivityDto
import dev.lingvo.shared.ProposalDecisionReceiptDto
import dev.lingvo.shared.ReaffirmTranslationRequest
import dev.lingvo.shared.SourceChangeDto
import dev.lingvo.shared.SourceReviewBatchRequest
import dev.lingvo.shared.SourceReviewDecisionRequest
import dev.lingvo.shared.SourceTranslationRequest
import dev.lingvo.shared.AddProjectLocaleRequest
import dev.lingvo.shared.ApiTokenDto
import dev.lingvo.shared.AuthResponse
import dev.lingvo.shared.BulkKeysRequest
import dev.lingvo.shared.BulkKeysResponse
import dev.lingvo.shared.BulkTranslationRequest
import dev.lingvo.shared.BulkTranslationResponse
import dev.lingvo.shared.CommentDto
import dev.lingvo.shared.CreateCommentRequest
import dev.lingvo.shared.UpdateCommentRequest
import dev.lingvo.shared.CreateFileRequest
import dev.lingvo.shared.CreateKeyRequest
import dev.lingvo.shared.BillingDocumentDto
import dev.lingvo.shared.BillingOverviewDto
import dev.lingvo.shared.BillingPortalDto
import dev.lingvo.shared.CheckoutDto
import dev.lingvo.shared.CreateProjectRequest
import dev.lingvo.shared.CreateWorkspaceRequest
import dev.lingvo.shared.OrgDto
import dev.lingvo.shared.UpdateWorkspaceRequest
import dev.lingvo.shared.CreateTokenRequest
import dev.lingvo.shared.Plan
import dev.lingvo.shared.StartCheckoutRequest
import dev.lingvo.shared.CreatedTokenDto
import dev.lingvo.shared.FileDto
import dev.lingvo.shared.FileFormat
import dev.lingvo.shared.GlossaryTermDto
import dev.lingvo.shared.BindStoreAppRequest
import dev.lingvo.shared.CreateStoreConnectionRequest
import dev.lingvo.shared.FitKeywordsRequest
import dev.lingvo.shared.StoreKeywordPlanDto
import dev.lingvo.shared.StoreAppDto
import dev.lingvo.shared.StoreConnectionDto
import dev.lingvo.shared.StoreDiffDto
import dev.lingvo.shared.StoreImportResultDto
import dev.lingvo.shared.StorePlatform
import dev.lingvo.shared.StorePushDto
import dev.lingvo.shared.StorePushRequest
import dev.lingvo.shared.HistoryEntryDto
import dev.lingvo.shared.KeyHistoryPageDto
import dev.lingvo.shared.AgentConnectionDto
import dev.lingvo.shared.AgentLogDto
import dev.lingvo.shared.ChangeEmailRequest
import dev.lingvo.shared.DecideSpendRequest
import dev.lingvo.shared.DeleteWorkspaceRequest
import dev.lingvo.shared.TransferOwnershipRequest
import dev.lingvo.shared.WorkspaceDeletionScopeDto
import dev.lingvo.shared.NotificationEvent
import dev.lingvo.shared.NotificationSettingsDto
import dev.lingvo.shared.UpdateNotificationRequest
import dev.lingvo.shared.TokenUsageDto
import dev.lingvo.shared.UpdateProfileRequest
import dev.lingvo.shared.WebhookDeliveriesDto
import dev.lingvo.shared.PausedAllDto
import dev.lingvo.shared.UpdateAgentLimitsRequest
import dev.lingvo.shared.RotatedAgentTokenDto
import dev.lingvo.shared.SpendApprovalsDto
import dev.lingvo.shared.AuditPageDto
import dev.lingvo.shared.CreateAgentConnectionRequest
import dev.lingvo.shared.CreateWebhookRequest
import dev.lingvo.shared.SessionDto
import dev.lingvo.shared.SpendGrouping
import dev.lingvo.shared.SpendReportDto
import dev.lingvo.shared.WebhookDto
import dev.lingvo.shared.WorkLogEntryDto
import dev.lingvo.shared.CloseAccountPreviewDto
import dev.lingvo.shared.ImportPlanDto
import dev.lingvo.shared.ImportRequest
import dev.lingvo.shared.ImportResultDto
import dev.lingvo.shared.KeyDto
import dev.lingvo.shared.KeyListResponse
import dev.lingvo.shared.LoginRequest
import dev.lingvo.shared.MeResponse
import dev.lingvo.shared.FormatDto
import dev.lingvo.shared.KeyCoverageDto
import dev.lingvo.shared.KeyDetailDto
import dev.lingvo.shared.MtEstimateDto
import dev.lingvo.shared.MtJobDto
import dev.lingvo.shared.MtJobsDto
import dev.lingvo.shared.CreateQaIgnoreRequest
import dev.lingvo.shared.QaIgnoresCreatedDto
import dev.lingvo.shared.CreateQaIgnoresRequest
import dev.lingvo.shared.QaCheck
import dev.lingvo.shared.QaIgnoresDto
import dev.lingvo.shared.QaRuleDto
import dev.lingvo.shared.QaRulesResponse
import dev.lingvo.shared.QaSeverity
import dev.lingvo.shared.QaSummaryDto
import dev.lingvo.shared.UpdateQaRuleRequest
import dev.lingvo.shared.MtJobState
import dev.lingvo.shared.MtPretranslateRequest
import dev.lingvo.shared.MtProvider
import dev.lingvo.shared.MtTranslateRequest
import dev.lingvo.shared.MtTranslateResponse
import dev.lingvo.shared.PresenceDto
import dev.lingvo.shared.PresenceHeartbeatRequest
import dev.lingvo.shared.PresenceResponse
import dev.lingvo.shared.ProjectDetailDto
import dev.lingvo.shared.ProjectSummaryDto
import dev.lingvo.shared.AcceptInvitationRequest
import dev.lingvo.shared.AcceptedInvitationDto
import dev.lingvo.shared.CreateInvitationRequest
import dev.lingvo.shared.CreatedInvitationDto
import dev.lingvo.shared.MembersResponse
import dev.lingvo.shared.ReviewStatus
import dev.lingvo.shared.Role
import dev.lingvo.shared.UpdateMemberRequest
import dev.lingvo.shared.PasswordResetAcceptedDto
import dev.lingvo.shared.PasswordResetConfirmRequest
import dev.lingvo.shared.PasswordResetRequest
import dev.lingvo.shared.ResendVerificationResponse
import dev.lingvo.shared.DeviceApprovalDto
import dev.lingvo.shared.DismissAttentionRequest
import dev.lingvo.shared.MentionDto
import dev.lingvo.shared.OverviewResponse
import dev.lingvo.shared.DecideProposalsRequest
import dev.lingvo.shared.GitHubClaimInstallationRequest
import dev.lingvo.shared.GitHubImportRequest
import dev.lingvo.shared.GitHubInstallUrlDto
import dev.lingvo.shared.GitHubInstallationsDto
import dev.lingvo.shared.GitHubImportResultDto
import dev.lingvo.shared.GitHubRepoDto
import dev.lingvo.shared.GitHubScanDto
import dev.lingvo.shared.ProposalPageDto
import dev.lingvo.shared.ReadinessDto
import dev.lingvo.shared.ReleaseCheckReportDto
import dev.lingvo.shared.RELEASE_POLICY_REVIEWED_CURRENT
import dev.lingvo.shared.RELEASE_SCOPE_HOSTED_PROJECT
import dev.lingvo.shared.ReviewAction
import dev.lingvo.shared.ReviewBatchRequest
import dev.lingvo.shared.ReviewBatchResponse
import dev.lingvo.shared.ReviewDecisionRequest
import dev.lingvo.shared.ReviewQueueDto
import dev.lingvo.shared.UsageDto
import dev.lingvo.shared.WorkResponse
import dev.lingvo.shared.WorkspaceDto
import dev.lingvo.shared.VerifyEmailRequest
import dev.lingvo.shared.AuthProvidersDto
import dev.lingvo.shared.OAuthExchangeRequest
import dev.lingvo.shared.SampleProjectDto
import dev.lingvo.shared.ProviderSettingsDto
import dev.lingvo.shared.ProviderTestResultDto
import dev.lingvo.shared.QaIssueDto
import dev.lingvo.shared.RegisterRequest
import dev.lingvo.shared.SuggestionDto
import dev.lingvo.shared.TranslationDto
import dev.lingvo.shared.TranslationState
import dev.lingvo.shared.UpdateKeyRequest
import dev.lingvo.shared.UpdateProjectRequest
import dev.lingvo.shared.UpdateProviderSettingsRequest
import dev.lingvo.shared.UpdateWorkspaceProviderRequest
import dev.lingvo.shared.WorkspaceProviderDto
import dev.lingvo.shared.WorkspaceProviderSaveResultDto
import dev.lingvo.shared.UpsertGlossaryTermRequest
import dev.lingvo.shared.UpsertTranslationRequest
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.jsonObject
import org.w3c.files.Blob
import dev.lingvo.shared.InsightsDto
import dev.lingvo.shared.DeletedKeysDto

class ApiException(
    val status: Int,
    val code: String,
    override val message: String,
    /**
     * The error's structured payload, when it has one.
     *
     * Kept because some refusals are not just a message: a `409 translation_conflict` carries the
     * translation that is actually stored, and without it the editor could tell someone their save
     * failed but not show them what it collided with — which makes the conflict card impossible and
     * leaves "keep mine / take theirs" as a choice nobody can make.
     */
    val details: JsonObject = JsonObject(emptyMap()),
) : RuntimeException(message)

object ApiClient {
    suspend fun register(email: String, password: String, name: String, acquisitionSource: String? = null): AuthResponse =
        register(RegisterRequest(email = email, password = password, name = name,
            acquisitionSource = dev.lingvo.shared.AcquisitionSource.fromTag(acquisitionSource).tag))

    suspend fun register(request: RegisterRequest): AuthResponse =
        jsonRequest("POST", "/auth/register", request, authenticated = false)

    suspend fun login(email: String, password: String): AuthResponse =
        login(LoginRequest(email = email, password = password))

    suspend fun login(request: LoginRequest): AuthResponse =
        jsonRequest("POST", "/auth/login", request, authenticated = false)

    suspend fun me(): MeResponse = jsonRequest("GET", "/auth/me", timeoutMs = 10_000)

    suspend fun createApiToken(request: CreateTokenRequest): CreatedTokenDto =
        jsonRequest("POST", "/auth/tokens", request)

    suspend fun listApiTokens(): List<ApiTokenDto> = jsonRequest("GET", "/auth/tokens")

    suspend fun deleteApiToken(tokenId: String) {
        unitRequest("DELETE", "/auth/tokens/${segment(tokenId)}")
    }

    /**
     * Everything `/app` needs, in one call.
     *
     * The page used to fetch the project list and then fan out one activity request per project
     * from the browser: twelve projects on a cold machine was a six-second first paint.
     */
    suspend fun overview(orgSlug: String): OverviewResponse =
        jsonRequest("GET", "/overview${query("org" to orgSlug)}")

    /** Put one attention item away for a week. Per person, never per workspace. */
    suspend fun dismissAttention(orgSlug: String, key: String) {
        unitRequest(
            "POST",
            "/overview/attention/dismiss${query("org" to orgSlug)}",
            DismissAttentionRequest(key),
        )
    }

    /**
     * Take one dismissal back, so "Show them again" is true rather than a label on nothing.
     *
     * 204 whether or not a row was there: undoing something already undone is the outcome the caller
     * asked for. Per person, exactly like [dismissAttention] — an admin un-hiding a billing warning
     * must not un-hide it for the owner either.
     */
    suspend fun restoreAttention(orgSlug: String, key: String) {
        unitRequest(
            "DELETE",
            "/overview/attention/dismiss/${segment(key)}${query("org" to orgSlug)}",
        )
    }

    /** What a terminal is asking for, before anybody approves it. */
    suspend fun deviceApproval(userCode: String): DeviceApprovalDto =
        jsonRequest("GET", "/auth/device/approval/${userCode.trim()}")

    /** Approve a pairing. No secret comes back here — the terminal collects it. */
    suspend fun approveDevice(userCode: String) {
        unitRequest("POST", "/auth/device/approval/${userCode.trim()}/approve")
    }

    suspend fun denyDevice(userCode: String) {
        unitRequest("POST", "/auth/device/approval/${userCode.trim()}/deny")
    }

    /**
     * What an import would do, without doing any of it.
     *
     * Mandatory before a commit: the plan is named by id when committing, so there is no way to
     * agree to one thing and apply another.
     */
    suspend fun planImport(slug: String, request: ImportRequest): ImportPlanDto =
        jsonRequest("POST", "/projects/${segment(slug)}/import/plan", request)

    /**
     * Applies a plan. Refused with `plan_stale` if the project moved since it was made.
     *
     * Takes the whole [ImportRequest], not a plan id alone, because the file is re-sent rather than
     * stored — a 40,000-key upload does not belong in a row that lives ten minutes — and the server
     * hashes it against the plan's fingerprint. That check is what stops "commit plan X" applying a
     * different file from the one X described, so `content` is not optional here.
     */
    suspend fun commitImport(slug: String, request: ImportRequest): ImportResultDto =
        jsonRequest("POST", "/projects/${segment(slug)}/import/commit", request)

    /**
     * Where to send somebody to install the app, carrying the state that binds the result here.
     *
     * Minted server-side per person per workspace. The installation id GitHub hands back on the
     * return is a public identifier and proves nothing on its own — this is what makes it mean
     * "the installation *this* workspace just created".
     */
    suspend fun gitHubInstallUrl(orgSlug: String): GitHubInstallUrlDto =
        jsonRequest("GET", "/github/install-url" + query("orgSlug" to orgSlug))

    /** The return leg. Binds the installation GitHub reported to the workspace that started it. */
    suspend fun gitHubInstallations(orgSlug: String): GitHubInstallationsDto =
        jsonRequest("GET", "/github/installations${query("orgSlug" to orgSlug)}")

    suspend fun claimGitHubInstallation(installationId: Long, state: String) {
        unitRequest(
            "POST",
            "/github/installations/claim",
            GitHubClaimInstallationRequest(installationId = installationId, state = state),
        )
    }

    /**
     * The repositories this installation can see.
     *
     * The route has always existed and nothing called it, so the import asked people to type an
     * owner and a repository by hand — for a list the server already had, chosen on GitHub's own
     * screen minutes earlier.
     */
    suspend fun listGitHubRepos(installationId: String): List<GitHubRepoDto> =
        jsonRequest("GET", "/github/repos/${segment(installationId)}")

    /** What a repository contains, offered for correction. Creates nothing. */
    suspend fun scanRepository(installationId: String, owner: String, repo: String): GitHubScanDto =
        jsonRequest("GET", "/github/scan/${segment(installationId)}/${segment(owner)}/${segment(repo)}")

    /**
     * Pulls the chosen files in, and says what actually landed.
     *
     * Creates a project when `request.projectSlug` is null, and imports into an existing one when it
     * is not — the second is somebody who already has a project and wants their repository's strings
     * in it, rather than a second project for the same app.
     *
     * The result carries per-file counts rather than "we fetched N files": the old response counted
     * downloads, which read as success while nothing was written.
     */
    suspend fun importFromGitHub(
        installationId: String,
        request: GitHubImportRequest,
    ): GitHubImportResultDto =
        jsonRequest("POST", "/github/import/${segment(installationId)}", request)

    /** What the agents suggested, waiting on a person. */
    suspend fun proposals(slug: String, locale: String? = null): ProposalPageDto =
        jsonRequest(
            "GET",
            "/projects/${segment(slug)}/proposals" + query("locale" to locale),
        )

    /** Accept or reject, one or a whole run. */
    suspend fun decideProposals(slug: String, request: DecideProposalsRequest) {
        unitRequest("POST", "/projects/${segment(slug)}/proposals/decide", request)
    }

    /** Opt-in named committed results; an old server's aggregate response remains distinguishable. */
    suspend fun decideProposalsWithReceipt(slug: String, request: DecideProposalsRequest): ProposalDecisionReceiptDto =
        jsonRequest("POST", "/projects/${segment(slug)}/proposals/decide?receipt=items", request)

    /**
     * One locale's strings waiting on a reviewer, oldest first.
     *
     * @param limit 1..100. The server **refuses** anything outside that rather than clamping, so a
     *   page size nobody asked for is never silently substituted for one they did.
     * @param after the previous page's `nextCursor`. The cursor is `updatedAt|keyId`, so it carries
     *   a `:` and a `|`; [query] percent-encodes it. The raw interpolation this replaced did not,
     *   which is the whole reason the three review/readiness paths were rewritten.
     */
    suspend fun reviewQueue(
        slug: String,
        locale: String,
        limit: Int? = null,
        after: String? = null,
    ): ReviewQueueDto = jsonRequest(
        "GET",
        "/projects/${segment(slug)}/review/${segment(locale)}" +
            query("limit" to limit?.toString(), "after" to after),
    )

    /** One decision. The version is sent so a string edited underneath a reviewer is refused. */
    suspend fun reviewDecision(
        slug: String,
        locale: String,
        keyId: String,
        action: ReviewAction,
        note: String?,
        expectedUpdatedAt: String?,
    ) {
        unitRequest(
            "POST",
            "/projects/${segment(slug)}/review/${segment(locale)}/${segment(keyId)}",
            ReviewDecisionRequest(action = action, note = note, expectedUpdatedAt = expectedUpdatedAt),
        )
    }

    /**
     * A screenful of decisions, each decided on its own merits.
     *
     * Partial-tolerant: the response says what happened to every item, and one blocked string does
     * not refuse the other hundred. Send [ReviewBatchRequest.dryRun] first — that is the same code
     * path with nothing written, and it is what the confirmation dialog states its counts from, so
     * the number somebody agrees to is the number that happens.
     *
     * Refusals to surface rather than swallow: `400 batch_too_large` above
     * [dev.lingvo.shared.MAX_REVIEW_BATCH] items, `400 note_required` on `REQUEST_CHANGES` with no
     * note, `400 unsupported_action` for `SKIP`. The cap is deliberately *not* checked here — a
     * client-side `require` would throw where the product needs a sentence a reviewer can read.
     */
    suspend fun reviewDecideBatch(
        slug: String,
        locale: String,
        request: ReviewBatchRequest,
    ): ReviewBatchResponse = jsonRequest(
        "POST",
        "/projects/${segment(slug)}/review/${segment(locale)}/decide-batch",
        request,
    )

    /**
     * Can we ship. The same call the CI gate makes, so the band and a red build agree.
     *
     * @param locale one language, for a pipeline that ships them independently. A locale the project
     *   does not have is a 400 rather than an empty "release-ready", which would be a green CI run
     *   that means nothing.
     * @param tag "can we ship 8.4", without branching: the readiness of the keys carrying one tag.
     */
    suspend fun readiness(
        slug: String,
        locale: String? = null,
        tag: String? = null,
    ): ReadinessDto = jsonRequest(
        "GET",
        "/projects/${segment(slug)}/readiness" + query("locale" to locale, "tag" to tag),
    )

    /** Every unresolved comment naming you. The "see all" behind the queue's Mentions section. */
    suspend fun mentions(): List<MentionDto> = jsonRequest("GET", "/me/mentions")

    /** Everything waiting on the signed-in person, in one call. Never takes a user id. */
    suspend fun work(workspace: String? = null): WorkResponse =
        jsonRequest("GET", "/me/work${query("workspace" to workspace)}")

    suspend fun insights(workspace: String, days: Int): InsightsDto =
        jsonRequest("GET", "/orgs/${segment(workspace)}/insights?days=$days")

    suspend fun listProjects(workspace: String? = null): List<ProjectSummaryDto> =
        jsonRequest("GET", "/projects${query("workspace" to workspace)}")

    suspend fun createProject(request: CreateProjectRequest): ProjectDetailDto =
        jsonRequest("POST", "/projects", request)

    suspend fun getProject(projectSlug: String): ProjectDetailDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}")

    suspend fun updateProject(projectSlug: String, request: UpdateProjectRequest): ProjectDetailDto =
        jsonRequest("PATCH", "/projects/${segment(projectSlug)}", request)

    /**
     * The uploaded mark, as bytes.
     *
     * **Not a URL, and the reason is the whole feature.** The first version of this returned
     * `"${'$'}{ApiConfig.baseUrl}/projects/…/icon"` for an `<img src>`, which cannot work: the
     * endpoint is inside `authenticate(AUTH_PROVIDER)`, the only provider is bearer, and the
     * session token lives in localStorage. An `<img>` sends no `Authorization` header, so every
     * request was answered 401 and every uploaded icon rendered as a broken-image glyph. Verified
     * against the running server: with a token, 200 image/png; without, 401 unauthorized.
     *
     * Going through `blobRequest` puts the token on the request like every other authenticated
     * fetch in this client. The caller turns the blob into an object URL and revokes it.
     */
    suspend fun projectIcon(projectSlug: String): Blob =
        blobRequest("GET", "/projects/${segment(projectSlug)}/icon", IMAGE_ACCEPT)

    /** The three types the icon endpoint can return; it never serves anything else. */
    private const val IMAGE_ACCEPT = "image/png, image/jpeg, image/webp"

    /** Replaces the mark. The server proves the type from the bytes and refuses anything else. */
    suspend fun uploadProjectIcon(projectSlug: String, file: Blob) {
        binaryRequest("PUT", "/projects/${segment(projectSlug)}/icon", file)
    }

    /** Back to the preset icon the project already carries. */
    suspend fun deleteProjectIcon(projectSlug: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/icon")
    }

    suspend fun deleteProject(projectSlug: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}")
    }

    suspend fun addProjectLocale(
        projectSlug: String,
        request: AddProjectLocaleRequest,
    ): ProjectDetailDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/locales",
        request,
    )

    suspend fun removeProjectLocale(projectSlug: String, locale: String) {
        unitRequest(
            "DELETE",
            "/projects/${segment(projectSlug)}/locales/${segment(locale)}",
        )
    }

    suspend fun listProjectActivity(
        projectSlug: String,
        limit: Int = 50,
    ): List<ActivityDto> = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/activity${query("limit" to limit.toString())}",
    )

    suspend fun listFiles(projectSlug: String): List<FileDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/files")

    suspend fun createFile(projectSlug: String, request: CreateFileRequest): FileDto =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/files", request)

    suspend fun deleteFile(projectSlug: String, fileId: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/files/${segment(fileId)}")
    }

    suspend fun listKeys(
        projectSlug: String,
        locale: String? = null,
        fileId: String? = null,
        search: String? = null,
        state: TranslationState? = null,
        tag: String? = null,
        /** A reviewer's verdict. The queue's "Changes requested" row is the only caller today. */
        review: ReviewStatus? = null,
        /** Only strings whose source has moved on since the translation was written. */
        stale: Boolean = false,
        limit: Int = 100,
        /**
         * The previous page's `nextCursor`, and the only way to reach a second page.
         *
         * `offset` used to sit beside this and the server used to honour it. Both are gone: rows
         * change state while someone works, and an offset that shifts underneath silently skips rows
         * the client then never renders. Sending one now earns a 400 rather than a wrong page.
         */
        after: String? = null,
    ): KeyListResponse = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/keys" + query(
            "locale" to locale,
            "fileId" to fileId,
            "search" to search,
            "state" to state?.name,
            "review" to review?.name,
            "stale" to true.takeIf { stale }?.toString(),
            "tag" to tag,
            "limit" to limit.toString(),
            "after" to after,
        ),
    )

    /**
     * State, not text, for the coverage matrix a keys list draws one dot per cell from.
     *
     * A dedicated call rather than `refLocales` on [listKeys]: that parameter is capped server-side
     * because each locale it carries multiplies the payload of the heaviest response in the product,
     * and it carries full [dev.lingvo.shared.TranslationDto] text. This carries an enum, so every
     * target locale can come back for every key on the visible page without that cost.
     *
     * Costs nothing when [keyIds] is empty: no request is made at all.
     */
    suspend fun keyCoverage(
        projectSlug: String,
        keyIds: List<String>,
        locales: List<String>,
    ): List<KeyCoverageDto> {
        if (keyIds.isEmpty() || locales.isEmpty()) return emptyList()
        // **Batched, because the ids ride in the URL.** A keys page holds 200 rows and a UUID is 36
        // characters, so one request for a page put over 7,000 characters on the request line —
        // past the HTTP engine's 4KB limit, which answers a bare 400 before any application code
        // (CORS included) runs. The browser reported that as a failed preflight with no
        // Access-Control-Allow-Origin header, which is true and useless. Forty ids is ~1.5KB with
        // the locales, leaving headroom for a long slug, and the batches run concurrently so the
        // page still fills in one round trip.
        return coroutineScope {
            coverageBatches(keyIds).map { batch ->
                async {
                    jsonRequest<List<KeyCoverageDto>>(
                        "GET",
                        "/projects/${segment(projectSlug)}/keys/coverage" + query(
                            "keyIds" to batch.joinToString(","),
                            "locales" to locales.joinToString(","),
                        ),
                    )
                }
            }.awaitAll().flatten()
        }
    }

    suspend fun createKey(projectSlug: String, request: CreateKeyRequest): KeyDto =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/keys", request)

    suspend fun updateKey(
        projectSlug: String,
        keyId: String,
        request: UpdateKeyRequest,
    ): KeyDto = jsonRequest(
        "PATCH",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}",
        request,
    )

    suspend fun deleteKey(projectSlug: String, keyId: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/keys/${segment(keyId)}")
    }

    /**
     * The keys this project has deleted, newest first.
     *
     * A delete has always been a soft one, so nothing was ever destroyed — but nothing could reach
     * it either, which made the reader's experience identical to the destructive version.
     */
    suspend fun deletedKeys(projectSlug: String): DeletedKeysDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/keys/deleted")

    /** Puts a deleted key back, with the translations that were still attached to it. */
    suspend fun restoreKey(projectSlug: String, keyId: String) {
        unitRequest("POST", "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/restore")
    }

    /**
     * One decision about many keys, in one transaction, with a receipt.
     *
     * Send either [BulkKeysRequest.keyIds] — what the reader ticked — or [BulkKeysRequest.filter],
     * which is "all N matching" and resolves through the same predicate builder `GET /keys` uses.
     * Never both: the server refuses that with `400 validation_error` rather than picking one.
     *
     * The response is partial-tolerant on purpose. [BulkKeysResponse.applied] is what actually
     * changed and [BulkKeysResponse.skipped] says why each of the rest did not — a key somebody else
     * deleted, restored or renamed between the page loading and the button being pressed. Render
     * both; a caller that reports its own request length as the count would overstate it.
     *
     * Refusals to surface rather than swallow: `400 too_many_keys` above
     * [dev.lingvo.shared.MAX_BULK_KEYS] — whether the request listed them or a filter resolved that
     * many — `400 tag_required` for a tag operation with no tag,
     * `400 validation_error` for a filtered `RESTORE` (a filter resolves what the list shows, and a
     * deleted key is not one of them) and for a filter that matches nothing, and `404` when the
     * request names ids this project has never had.
     */
    suspend fun keysBulk(projectSlug: String, request: BulkKeysRequest): BulkKeysResponse =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/keys/bulk", request)

    /**
     * @param ifMatch the `updated_at` this edit started from.
     *
     * Sent by the editor and nothing else. Without it the save is last-write-wins, which with an
     * 800ms autosave means two people on one string quietly overwrite each other between keystrokes.
     */
    /**
     * One call that both reports where this person is and reads where everyone else is.
     *
     * Every failure is swallowed by the caller: presence is a line of grey text, and an editor that
     * showed an error because a heartbeat missed would be worse than one that shows nothing.
     */
    suspend fun presence(
        projectSlug: String,
        request: PresenceHeartbeatRequest,
    ): PresenceResponse = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/presence",
        request,
    )

    suspend fun updateTranslation(
        projectSlug: String,
        keyId: String,
        locale: String,
        request: UpsertTranslationRequest,
        ifMatch: String? = null,
    ): TranslationDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/translations/${segment(locale)}",
        request,
        headers = ifMatch?.let { mapOf("If-Match" to it) }.orEmpty(),
    )

    /** Inspect exact current and recorded source text. Unavailable earlier history stays null. */
    suspend fun sourceChange(
        projectSlug: String,
        keyId: String,
        locale: String,
    ): SourceChangeDto = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/source-change" + query("locale" to locale),
    )

    /** A distinct point-in-time policy read. Ordinary readiness is never a fallback. */
    suspend fun reviewedCurrentReleaseCheck(
        projectSlug: String,
        locale: String? = null,
    ): ReleaseCheckReportDto {
        val path = "/projects/${segment(projectSlug)}/release-checks/reviewed-current" + query("locale" to locale)
        val report = jsonRequest<ReleaseCheckReportDto>("GET", path)
        if (report.policy != RELEASE_POLICY_REVIEWED_CURRENT || report.scope.kind != RELEASE_SCOPE_HOSTED_PROJECT ||
            report.scope.projectSlug != projectSlug || locale != null && report.scope.locales != listOf(locale)
        ) {
            throw invalidResponse(path, IllegalArgumentException("The reviewed/current report does not match the requested scope."))
        }
        return report
    }

    /** Distinct URL: an older server must refuse instead of ignoring the source/target claims. */
    suspend fun updateTranslationForSource(
        projectSlug: String,
        keyId: String,
        locale: String,
        request: SourceTranslationRequest,
    ): TranslationDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/translations/${segment(locale)}/for-source",
        // The shared transport omits optional nulls. This null is a required absence claim.
        JsonObject(API_JSON.encodeToJsonElement(request).jsonObject.let { fields ->
            if (request.expectedTargetRevision == null) fields + ("expectedTargetRevision" to JsonNull)
            else fields
        }),
    )

    /** Explicitly reaffirm unchanged text; never substitute a save or an approval on refusal. */
    suspend fun reaffirmTranslation(
        projectSlug: String,
        keyId: String,
        locale: String,
        request: ReaffirmTranslationRequest,
    ): TranslationDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/translations/${segment(locale)}/reaffirm",
        request,
    )

    suspend fun reviewDecisionForSource(
        slug: String,
        locale: String,
        keyId: String,
        request: SourceReviewDecisionRequest,
    ) {
        unitRequest(
            "POST",
            "/projects/${segment(slug)}/review/${segment(locale)}/${segment(keyId)}/for-source",
            request,
        )
    }

    suspend fun reviewDecideBatchForSource(
        slug: String,
        locale: String,
        request: SourceReviewBatchRequest,
    ): ReviewBatchResponse = jsonRequest(
        "POST",
        "/projects/${segment(slug)}/review/${segment(locale)}/decide-batch-for-source",
        request,
    )

    suspend fun bulkTranslations(
        projectSlug: String,
        request: BulkTranslationRequest,
    ): BulkTranslationResponse = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/translations/bulk",
        request,
    )

    suspend fun getKeyHistory(
        projectSlug: String,
        keyId: String,
        locale: String? = null,
        after: String? = null,
    ): KeyHistoryPageDto = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/history" +
            query("locale" to locale, "after" to after),
    )

    suspend fun listKeyComments(projectSlug: String, keyId: String): List<CommentDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/comments")

    suspend fun createKeyComment(
        projectSlug: String,
        keyId: String,
        request: CreateCommentRequest,
    ): CommentDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/comments",
        request,
    )

    suspend fun updateKeyComment(projectSlug: String, keyId: String, commentId: String, request: UpdateCommentRequest) {
        unitRequest(
            "PATCH",
            "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/comments/${segment(commentId)}",
            request,
        )
    }

    suspend fun deleteKeyComment(projectSlug: String, keyId: String, commentId: String) {
        unitRequest(
            "DELETE",
            "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/comments/${segment(commentId)}",
        )
    }

    suspend fun listSuggestions(
        projectSlug: String,
        keyId: String,
        locale: String,
    ): List<SuggestionDto> = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/keys/${segment(keyId)}/suggestions" +
            query("locale" to locale),
    )

    /**
     * The issues themselves.
     *
     * @param key one string's name, when that is what the caller wants. The editor used to re-read
     *   the project's entire QA state after every save.
     * @param severity filtered on the server **before** the cap, so `severity = ERROR, limit = 1` is
     *   the "first failure" call rather than a page of warnings with the errors truncated off it.
     */
    suspend fun qa(
        projectSlug: String,
        locale: String? = null,
        key: String? = null,
        severity: QaSeverity? = null,
        limit: Int? = null,
    ): List<QaIssueDto> = jsonRequest("GET", qaPath(projectSlug, locale, key, severity, limit, counts = false))

    /**
     * The same query, with the totals around it.
     *
     * A separate function rather than a `counts` flag on [qa] because the response *shape* changes:
     * `counts=true` answers with a [QaSummaryDto] and anything else answers with the bare list, and a
     * return type cannot depend on an argument's runtime value. Both read the same route, so the
     * heading a page draws from [QaSummaryDto.countsByCheck] cannot disagree with the rows under it.
     *
     * The counts are computed over everything the filter matched, before the cap —
     * [QaSummaryDto.truncated] is how a surface knows it is showing a page of [QaSummaryDto.total].
     */
    suspend fun qaSummary(
        projectSlug: String,
        locale: String? = null,
        key: String? = null,
        severity: QaSeverity? = null,
        limit: Int? = null,
    ): QaSummaryDto = jsonRequest("GET", qaPath(projectSlug, locale, key, severity, limit, counts = true))

    /** Lowercase severity, because that is the vocabulary the route parses (`error` / `warning`). */
    private fun qaPath(
        projectSlug: String,
        locale: String?,
        key: String?,
        severity: QaSeverity?,
        limit: Int?,
        counts: Boolean,
    ): String = "/projects/${segment(projectSlug)}/qa" + query(
        "locale" to locale,
        "key" to key,
        "severity" to severity?.name?.lowercase(),
        "limit" to limit?.toString(),
        "counts" to true.takeIf { counts }?.toString(),
    )

    suspend fun importFile(projectSlug: String, request: ImportRequest): ImportResultDto =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/import", request)

    suspend fun exportFile(
        projectSlug: String,
        fileId: String,
        locale: String,
        format: FileFormat? = null,
        fallbackToSource: Boolean = false,
    ): String {
        val path = "/projects/${segment(projectSlug)}/export" + query(
            "fileId" to fileId,
            "locale" to locale,
            "format" to format?.name,
            "fallbackToSource" to fallbackToSource.toString(),
        )
        return textRequest("GET", path, TEXT_CONTENT_TYPE)
    }

    suspend fun exportBundle(
        projectSlug: String,
        locales: List<String> = emptyList(),
        format: FileFormat? = null,
    ): Blob {
        val path = "/projects/${segment(projectSlug)}/export/bundle" + query(
            "locales" to locales.takeIf(List<String>::isNotEmpty)?.joinToString(","),
            "format" to format?.name,
        )
        return blobRequest("GET", path, ZIP_CONTENT_TYPE)
    }

    suspend fun listGlossaryTerms(projectSlug: String): List<GlossaryTermDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/glossary")

    suspend fun createGlossaryTerm(
        projectSlug: String,
        request: UpsertGlossaryTermRequest,
    ): GlossaryTermDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/glossary",
        request,
    )

    suspend fun updateGlossaryTerm(
        projectSlug: String,
        termId: String,
        request: UpsertGlossaryTermRequest,
    ): GlossaryTermDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/glossary/${segment(termId)}",
        request,
    )

    suspend fun deleteGlossaryTerm(projectSlug: String, termId: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/glossary/${segment(termId)}")
    }

    // ---- store listings ---------------------------------------------------------------------
    //
    // Every route below is session-only on the server: reaching a live store is a human act, so an
    // API token never gets here. The connection secrets are write-only — [createStoreConnection]
    // sends them once and every response carries only `credentialHint`.

    /** The workspace's store credentials, secrets withheld. Owners and admins only. */
    suspend fun storeConnections(orgSlug: String): List<StoreConnectionDto> =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/store-connections")

    suspend fun createStoreConnection(
        orgSlug: String,
        request: CreateStoreConnectionRequest,
    ): StoreConnectionDto = jsonRequest(
        "POST",
        "/orgs/${segment(orgSlug)}/store-connections",
        request,
    )

    suspend fun deleteStoreConnection(orgSlug: String, connectionId: String) {
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}/store-connections/${segment(connectionId)}")
    }

    /** The store apps bound to this project, at most one per platform. */
    suspend fun storeApps(projectSlug: String): List<StoreAppDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/stores")

    suspend fun bindStoreApp(
        projectSlug: String,
        platform: StorePlatform,
        request: BindStoreAppRequest,
    ): StoreAppDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}",
        request,
    )

    suspend fun unbindStoreApp(projectSlug: String, platform: StorePlatform) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}")
    }

    /** Copies the live listing into the project. Local edits are kept unless [overwrite] is set. */
    suspend fun importStoreListing(
        projectSlug: String,
        platform: StorePlatform,
        overwrite: Boolean = false,
    ): StoreImportResultDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/import" +
            query("overwrite" to if (overwrite) "true" else null),
    )

    /** What a push would change, per store locale, and the token a push must present. */
    suspend fun storeDiff(projectSlug: String, platform: StorePlatform): StoreDiffDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/diff")

    suspend fun pushStoreListing(
        projectSlug: String,
        platform: StorePlatform,
        request: StorePushRequest,
    ): StorePushDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/push",
        request,
    )

    suspend fun storePushes(projectSlug: String, platform: StorePlatform): List<StorePushDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/pushes")

    /** Fits a locale's keyword draft to Apple's 100-byte field and saves it as an unapproved draft. */
    suspend fun fitStoreKeywords(projectSlug: String, locale: String): StoreKeywordPlanDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/stores/${segment(StorePlatform.APP_STORE.id)}/keywords/fit",
        FitKeywordsRequest(locale),
    )

    /** Sends a push the store queued, now that it may accept it. */
    suspend fun retryStorePush(projectSlug: String, platform: StorePlatform, pushId: String): StorePushDto =
        jsonRequest(
            "POST",
            "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/pushes/${segment(pushId)}/retry",
        )

    /**
     * Restores the text the store held before [pushId]. Recorded as a push of its own.
     *
     * Fields the push filled that had no earlier text cannot be taken back; the server refuses with
     * `store_rollback_incomplete` and names them until the caller sets [acknowledge].
     */
    suspend fun rollbackStorePush(
        projectSlug: String,
        platform: StorePlatform,
        pushId: String,
        acknowledge: Boolean = false,
    ): StorePushDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/stores/${segment(platform.id)}/pushes/${segment(pushId)}/rollback" +
            query("acknowledge" to if (acknowledge) "true" else null),
    )

    suspend fun requestPasswordReset(email: String): PasswordResetAcceptedDto =
        jsonRequest("POST", "/auth/password-reset", PasswordResetRequest(email), authenticated = false)

    suspend fun confirmPasswordReset(token: String, password: String): Unit =
        unitRequest("POST", "/auth/password-reset/confirm", PasswordResetConfirmRequest(token, password))

    suspend fun verifyEmail(token: String): Unit =
        unitRequest("POST", "/auth/verify-email", VerifyEmailRequest(token))

    suspend fun resendVerification(): ResendVerificationResponse =
        jsonRequest("POST", "/auth/verify-email/resend", EmptyBody())

    /** Which sign-in methods this deployment offers, so the page never shows a button that 404s. */
    suspend fun authProviders(): AuthProvidersDto =
        jsonRequest("GET", "/auth/providers", authenticated = false)

    /**
     * Trades the single-use code from the Google callback for a session.
     *
     * Unauthenticated by definition — this is what produces the credential.
     */
    suspend fun exchangeOAuthCode(code: String): AuthResponse =
        jsonRequest("POST", "/auth/google/exchange", OAuthExchangeRequest(code), authenticated = false)

    /** Fills a new workspace with a worked example so the product has something to show. */
    suspend fun createSampleProject(orgSlug: String? = null): SampleProjectDto =
        jsonRequest("POST", "/onboarding/sample-project${query("org" to orgSlug)}", EmptyBody())

    suspend fun usage(projectSlug: String): UsageDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/usage")

    /**
     * Asks for a checkout link. The seat count is not sent — the server takes it from the workspace.
     *
     * Returns a URL rather than changing anything. The plan moves only when the processor tells the
     * server that money moved, so there is nothing to optimistically update here.
     */
    suspend fun startCheckout(projectSlug: String, plan: Plan): CheckoutDto =
        jsonRequest(
            "POST",
            "/projects/${segment(projectSlug)}/billing/checkout",
            StartCheckoutRequest(plan),
        )

    suspend fun cancelSubscription(projectSlug: String) {
        unitRequest("POST", "/projects/${segment(projectSlug)}/billing/cancel")
    }

    suspend fun members(projectSlug: String): MembersResponse =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/members")

    /** Every workspace this person belongs to, with their role and plan in each. */
    suspend fun workspaces(): List<WorkspaceDto> = jsonRequest("GET", "/orgs")

    /**
     * The members of a workspace.
     *
     * The workspace's own address rather than a project's. Same answer, same function on the server
     * — but a member list reached through a project reads as project settings, and someone deleting
     * a project to tidy up should not have to wonder what else goes with it.
     */
    suspend fun workspaceMembers(orgSlug: String): MembersResponse =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/members")

    suspend fun workspaceUsage(orgSlug: String): UsageDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/usage")

    suspend fun workspaceProviders(orgSlug: String): List<WorkspaceProviderDto> =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/providers")

    /** Save and test are one call: a green "Saved" on a key that does not work is a trap. */
    suspend fun saveWorkspaceProvider(
        orgSlug: String,
        providerId: String,
        apiKey: String?,
        enabled: Boolean?,
    ): WorkspaceProviderSaveResultDto = jsonRequest(
        "PUT",
        "/orgs/${segment(orgSlug)}/providers/${segment(providerId)}",
        UpdateWorkspaceProviderRequest(enabled = enabled, apiKey = apiKey),
    )

    /** Your display name. The address has its own confirmed flow — deliberately not this one. */
    suspend fun updateProfile(name: String) {
        unitRequest("PATCH", "/account/profile", UpdateProfileRequest(name))
    }

    /**
     * Asks to change the address.
     *
     * Two-sided: a link goes to the new address and a notice to the old one, and nothing changes
     * until the link is followed.
     */
    suspend fun requestEmailChange(newEmail: String) {
        unitRequest("POST", "/account/email", ChangeEmailRequest(newEmail))
    }

    suspend fun cancelEmailChange() {
        unitRequest("POST", "/account/email/cancel")
    }

    suspend fun notificationSettings(): NotificationSettingsDto = jsonRequest("GET", "/account/notifications")

    suspend fun updateNotification(event: NotificationEvent, enabled: Boolean): NotificationSettingsDto =
        jsonRequest("PUT", "/account/notifications", UpdateNotificationRequest(event, enabled))

    /** What one token has been doing, by route pattern — never a customer's project slug. */
    suspend fun tokenUsage(id: String): List<TokenUsageDto> =
        jsonRequest("GET", "/auth/tokens/${segment(id)}/usage")

    /** What has been sent to one webhook. The payload is deliberately not in it. */
    suspend fun webhookDeliveries(orgSlug: String, id: String): WebhookDeliveriesDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/webhooks/${segment(id)}/deliveries")

    /** Sends one again, as a new delivery. The original row is left as evidence. */
    suspend fun replayDelivery(orgSlug: String, webhookId: String, deliveryId: String) {
        unitRequest(
            "POST",
            "/orgs/${segment(orgSlug)}/webhooks/${segment(webhookId)}/deliveries/${segment(deliveryId)}/replay",
        )
    }

    /** Switches one back on after too many failures switched it off. */
    /**
     * Issue a new signing secret, shown once.
     *
     * The only repair for a webhook created before secrets were stored in a form that can sign, and
     * the ordinary move when one leaks — deleting and re-adding changes the id and loses the
     * delivery history.
     */
    suspend fun rotateWebhookSecret(orgSlug: String, id: String): WebhookDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/webhooks/${segment(id)}/secret/rotate")

    suspend fun setWebhookEnabled(orgSlug: String, id: String, enabled: Boolean) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/webhooks/${segment(id)}/enabled?enabled=$enabled")
    }

    /** What closing your account would do, computed live rather than described in stale prose. */
    suspend fun closeAccountPreview(): CloseAccountPreviewDto = jsonRequest("GET", "/account/close")

    /** Schedules it, seven days out. */
    suspend fun closeAccount() {
        unitRequest("POST", "/account/close")
    }

    /** The one-click cancel. A 2am decision, recoverable at 9am. */
    suspend fun cancelAccountClose() {
        unitRequest("POST", "/account/close/cancel")
    }

    /** Everything that happened across every project, as the same sentences the overview uses. */
    suspend fun activity(orgSlug: String, limit: Int = 100): List<WorkLogEntryDto> =
        jsonRequest(
            "GET",
            "/activity${query("org" to orgSlug, "limit" to limit.toString())}",
        )

    /** The devices signed in as you. API tokens are deliberately not among them. */
    suspend fun sessions(): List<SessionDto> = jsonRequest("GET", "/auth/sessions")

    /** Ends one. The next request carrying its token gets a 401 — that is the whole point. */
    suspend fun revokeSession(id: String) {
        unitRequest("DELETE", "/auth/sessions/${segment(id)}")
    }

    suspend fun revokeOtherSessions() {
        unitRequest("POST", "/auth/sessions/revoke-others")
    }

    /** The agent connections in this workspace. The credential is never in this response. */
    suspend fun agents(orgSlug: String): List<AgentConnectionDto> =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/agents")

    /** Creates one. The returned DTO carries the `lgm_` token exactly once. */
    suspend fun createAgent(orgSlug: String, request: CreateAgentConnectionRequest): AgentConnectionDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/agents", request)

    /** Stops it without destroying the record of what it was. */
    suspend fun pauseAgent(orgSlug: String, id: String, paused: Boolean) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/agents/${segment(id)}/pause?paused=$paused")
    }

    /** What one agent has been doing, by tool and day. The refusals are why anybody opens it. */
    suspend fun agentLog(orgSlug: String, id: String): AgentLogDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/agents/${segment(id)}/log")

    /** The budgets and the expiry. Reaching further needs a new credential, not a wider one. */
    suspend fun updateAgentLimits(orgSlug: String, id: String, request: UpdateAgentLimitsRequest) {
        unitRequest("PATCH", "/orgs/${segment(orgSlug)}/agents/${segment(id)}", request)
    }

    /** Stops every agent at once. Reversible, and never dressed as revocation. */
    suspend fun pauseAllAgents(orgSlug: String): PausedAllDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/agents/pause-all")

    /** A new secret for the same connection. Same scopes, same budgets, same allowlist. */
    suspend fun rotateAgent(orgSlug: String, id: String): RotatedAgentTokenDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/agents/${segment(id)}/rotate")

    /** Spends an agent asked for and does not have budget for. Owners and admins only. */
    suspend fun spendApprovals(orgSlug: String): SpendApprovalsDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/agents/approvals")

    suspend fun decideSpend(orgSlug: String, id: String, approve: Boolean) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/agents/approvals/${segment(id)}", DecideSpendRequest(approve))
    }

    suspend fun revokeAgent(orgSlug: String, id: String) {
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}/agents/${segment(id)}")
    }

    /** Where the credits went, gross and refunded kept apart. Owners and admins only. */
    suspend fun spendReport(orgSlug: String, by: SpendGrouping): SpendReportDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/reports/spend?by=${by.name}")

    /** The workspace's webhooks. The signing secret is never in this response. */
    suspend fun webhooks(orgSlug: String): List<WebhookDto> =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/webhooks")

    /** Creates one. The returned DTO carries the secret exactly once. */
    suspend fun createWebhook(orgSlug: String, request: CreateWebhookRequest): WebhookDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/webhooks", request)

    suspend fun deleteWebhook(orgSlug: String, id: String) {
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}/webhooks/${segment(id)}")
    }

    /** What happened to the workspace: members, billing, provider keys. Owners and admins only. */
    suspend fun auditLog(orgSlug: String, action: String? = null, after: String? = null): AuditPageDto =
        jsonRequest(
            "GET",
            // The same `query()` idiom as everything else: the cursor is `createdAt|id`, and a
            // hand-rolled query string put its `|` and `:` on the wire unencoded.
            "/orgs/${segment(orgSlug)}/audit" + query("action" to action, "after" to after),
        )

    /** Every workspace this person is in, with the role they hold in each. */
    suspend fun listWorkspaces(): List<WorkspaceDto> = jsonRequest("GET", "/orgs")

    suspend fun createWorkspace(request: CreateWorkspaceRequest): OrgDto =
        jsonRequest("POST", "/orgs", request)

    suspend fun createWorkspace(name: String): OrgDto =
        jsonRequest("POST", "/orgs", CreateWorkspaceRequest(name))

    suspend fun renameWorkspace(orgSlug: String, name: String, slug: String? = null): Unit =
        unitRequest("PATCH", "/orgs/${segment(orgSlug)}", UpdateWorkspaceRequest(name, slug))

    /** What deleting this workspace would destroy, counted. Owner only. */
    suspend fun workspaceDeletionScope(orgSlug: String): WorkspaceDeletionScopeDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/deletion-scope")

    /**
     * Hands the last word to somebody else. The caller stays, as an admin.
     *
     * The password is required by the server, not by this client: a session left open on an unlocked
     * laptop is the threat, and a check the browser could skip would not be one.
     */
    suspend fun transferWorkspace(orgSlug: String, userId: String, password: String) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/transfer", TransferOwnershipRequest(userId, password))
    }

    /** Deletes it and everything in it. Refused server-side while a subscription is still live. */
    suspend fun deleteWorkspace(orgSlug: String, confirmSlug: String, password: String) {
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}", DeleteWorkspaceRequest(confirmSlug, password))
    }

    /**
     * A fresh link to the processor's billing screens. Never cached — it authenticates its holder.
     *
     * This is what a customer with a failing card actually needs; before it existed the product told
     * them to use a screen that was not there.
     */
    suspend fun billingPortal(orgSlug: String, invoices: Boolean = false): BillingPortalDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/billing/portal" + if (invoices) "?purpose=invoices" else "")

    /** Leaving is not being removed: available to anyone who is not the last owner. */
    suspend fun leaveWorkspace(orgSlug: String) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/leave")
    }

    /**
     * Ends the subscription at the end of the period.
     *
     * Workspace-scoped, because that is where the subscription lives — the project-scoped route is
     * the same handler reached through whichever project happened to be open.
     */
    /**
     * Asks for a checkout link for a workspace.
     *
     * The seat count is not sent — the server takes it from the workspace, so a client cannot buy
     * fewer seats than it is about to use.
     */
    suspend fun startWorkspaceCheckout(orgSlug: String, plan: Plan): CheckoutDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/billing/checkout", StartCheckoutRequest(plan))

    suspend fun cancelWorkspaceSubscription(orgSlug: String) {
        unitRequest("POST", "/orgs/${segment(orgSlug)}/billing/cancel")
    }

    /** Everything the billing page shows. Assembled server-side; no processor round-trip. */
    suspend fun workspaceBilling(orgSlug: String): BillingOverviewDto =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/billing")

    suspend fun previewWorkspacePlanChange(orgSlug: String, plan: Plan): dev.lingvo.shared.PlanChangePreviewDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/billing/plan-change/preview", dev.lingvo.shared.PreviewPlanChangeRequest(plan))

    suspend fun confirmWorkspacePlanChange(orgSlug: String, previewId: String): dev.lingvo.shared.PlanChangeAcceptedDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/billing/plan-change/confirm", dev.lingvo.shared.ConfirmPlanChangeRequest(previewId))

    suspend fun workspaceInvoices(orgSlug: String): List<BillingDocumentDto> =
        jsonRequest("GET", "/orgs/${segment(orgSlug)}/billing/invoices")

    suspend fun inviteToWorkspace(orgSlug: String, email: String, role: Role): CreatedInvitationDto =
        jsonRequest(
            "POST",
            "/orgs/${segment(orgSlug)}/invitations",
            CreateInvitationRequest(email = email, role = role),
        )

    suspend fun updateWorkspaceMemberRole(
        orgSlug: String,
        userId: String,
        role: Role,
        expectedBillableSeats: Int? = null,
    ): Unit = unitRequest(
        "PATCH",
        "/orgs/${segment(orgSlug)}/members/${segment(userId)}",
        UpdateMemberRequest(role = role, expectedBillableSeats = expectedBillableSeats),
    )

    /** Grants or withdraws approval rights. Free: a reviewer occupies no billable seat. */
    suspend fun setWorkspaceMemberReviewer(orgSlug: String, userId: String, canApprove: Boolean): Unit =
        unitRequest(
            "PATCH",
            "/orgs/${segment(orgSlug)}/members/${segment(userId)}",
            UpdateMemberRequest(canApprove = canApprove),
        )

    suspend fun removeWorkspaceMember(orgSlug: String, userId: String) {
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}/members/${segment(userId)}")
    }

    /**
     * @param expectedBillableSeats what the confirmation modal quoted. The server answers
     *   `409 seat_changed` if the number has moved, rather than charging a price nobody was shown.
     */
    suspend fun updateMemberRole(
        projectSlug: String,
        userId: String,
        role: Role,
        expectedBillableSeats: Int? = null,
    ): Unit =
        unitRequest(
            "PATCH",
            "/projects/${segment(projectSlug)}/members/${segment(userId)}",
            UpdateMemberRequest(role = role, expectedBillableSeats = expectedBillableSeats),
        )

    /** Grants or withdraws approval rights. Free: a reviewer occupies no billable seat. */
    suspend fun setMemberReviewer(projectSlug: String, userId: String, canApprove: Boolean): Unit =
        unitRequest(
            "PATCH",
            "/projects/${segment(projectSlug)}/members/${segment(userId)}",
            UpdateMemberRequest(canApprove = canApprove),
        )

    suspend fun removeMember(projectSlug: String, userId: String): Unit =
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/members/${segment(userId)}")

    suspend fun inviteMember(projectSlug: String, email: String, role: Role): CreatedInvitationDto =
        jsonRequest(
            "POST",
            "/projects/${segment(projectSlug)}/invitations",
            CreateInvitationRequest(email, role),
        )

    suspend fun revokeInvitation(projectSlug: String, invitationId: String): Unit =
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/invitations/${segment(invitationId)}")

    /**
     * Withdraw a pending workspace invitation.
     *
     * The route has always existed; nothing called it. Without a revoke, a mistyped address is
     * permanent: the partial unique index only clears on accept or revoke, never on expiry, so
     * re-inviting the right person at that address is refused with "already has a pending
     * invitation" — forever, for an invitation whose link nobody can produce.
     */
    suspend fun revokeWorkspaceInvitation(orgSlug: String, invitationId: String): Unit =
        unitRequest("DELETE", "/orgs/${segment(orgSlug)}/invitations/${segment(invitationId)}")

    suspend fun resendWorkspaceInvitation(orgSlug: String, invitationId: String): CreatedInvitationDto =
        jsonRequest("POST", "/orgs/${segment(orgSlug)}/invitations/${segment(invitationId)}/resend", EmptyBody())

    suspend fun acceptInvitation(token: String): AcceptedInvitationDto =
        jsonRequest("POST", "/invitations/accept", AcceptInvitationRequest(token))

    suspend fun listProviders(projectSlug: String): List<ProviderSettingsDto> =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/providers")

    suspend fun updateProvider(
        projectSlug: String,
        provider: MtProvider,
        request: UpdateProviderSettingsRequest,
        clearBaseUrl: Boolean = false,
        clearModel: Boolean = false,
        options: JsonObject? = null,
    ): ProviderSettingsDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/providers/${segment(provider.id)}",
        providerUpdateBody(request, options, clearBaseUrl, clearModel),
        authenticated = true,
    )

    suspend fun testProvider(
        projectSlug: String,
        provider: MtProvider,
    ): ProviderTestResultDto = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/providers/${segment(provider.id)}/test",
    )

    suspend fun translate(
        projectSlug: String,
        request: MtTranslateRequest,
    ): MtTranslateResponse = jsonRequest(
        "POST",
        "/projects/${segment(projectSlug)}/mt/translate",
        request,
    )

    /**
     * What a pre-translate would cost, computed by the server that would charge for it.
     *
     * Free, and it writes nothing: the route runs the same `planMtJob` the run itself is built from,
     * with the memory phase counted instead of applied. So the number in a confirmation dialog is the
     * server's arithmetic rather than the browser's approximation of it — an estimate that can
     * disagree with the charge is worse than no estimate, because it is believed.
     *
     * Take [request] straight from the form the button will post, so the two cannot describe
     * different runs. [MtPretranslateRequest.tone] is the one field the route does not read: it
     * changes the words, never the price.
     *
     * `blockedReason` on the response is a run that cannot start — a disabled, unusable or
     * key-less provider — and the counts beside it are still true. Say both; showing a price while
     * hiding that nothing will happen is how a disabled provider becomes a support ticket.
     *
     * **[MtPretranslateRequest.keyIds] rides in the URL here** because the route is a GET. A few
     * hundred ids is already a very long query string, so a hand-picked selection larger than a
     * screenful should be estimated by tag, file or locale instead; the server's own ceiling is
     * [dev.lingvo.shared.MAX_MT_PRETRANSLATE_KEYS].
     */
    suspend fun mtEstimate(projectSlug: String, request: MtPretranslateRequest): MtEstimateDto =
        jsonRequest(
            "GET",
            "/projects/${segment(projectSlug)}/mt/estimate" + query(
                "provider" to request.provider.id,
                "locales" to request.locales.joinToString(","),
                "onlyEmpty" to request.onlyEmpty.toString(),
                "tag" to request.tag,
                "fileId" to request.fileId,
                "keyIds" to request.keyIds.takeIf(List<String>::isNotEmpty)?.joinToString(","),
                "memoryOnly" to request.memoryOnly.toString(),
            ),
        )

    /** The same estimate, for a caller that has the selection but has not built a request yet. */
    suspend fun mtEstimate(
        projectSlug: String,
        provider: MtProvider,
        locales: List<String>,
        onlyEmpty: Boolean = true,
        tag: String? = null,
        fileId: String? = null,
        keyIds: List<String> = emptyList(),
        memoryOnly: Boolean = false,
    ): MtEstimateDto = mtEstimate(
        projectSlug,
        MtPretranslateRequest(
            provider = provider,
            locales = locales,
            onlyEmpty = onlyEmpty,
            tag = tag,
            fileId = fileId,
            keyIds = keyIds,
            memoryOnly = memoryOnly,
        ),
    )

    /**
     * Starts a run, and answers with its id.
     *
     * `409 job_already_running` is not a failure to report as one: `details.jobId` is the run that is
     * already translating these locales, and the caller attaches its poller to that instead of
     * starting a rival that would reserve credits for strings somebody is already paying for.
     */
    suspend fun pretranslate(
        projectSlug: String,
        request: MtPretranslateRequest,
    ): String = jsonRequest<MtPretranslateRequest, JobCreatedResponse>(
        "POST",
        "/projects/${segment(projectSlug)}/mt/pretranslate",
        request,
    ).jobId

    /**
     * Stops a run and gives back what it has not delivered.
     *
     * Answers with the job as it now stands, so a caller can render the receipt without a second
     * read. The refund is proportional — the strings already translated stay in the project and stay
     * paid for — and `MtJobDto.refundedCredits` is what actually came back, not the reservation.
     *
     * `409 job_not_running` means somebody else already stopped it, or it finished on its own.
     */
    suspend fun cancelMtJob(projectSlug: String, jobId: String): MtJobDto =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/mt/jobs/${segment(jobId)}/cancel")

    /**
     * Runs a failed job again, exactly as it was asked for the first time, and answers with the new
     * job's id.
     *
     * **No body, on purpose.** The intent — provider, locales, tone, gaps-only, and which tag, file
     * or hand-picked keys it covered — is read back from the stored row rather than from the caller,
     * because half of it is not recoverable from memory a day later and a "retry" that translates a
     * different set is not one. What the server re-resolves is the *selection*, not the item list, so
     * the half a failed run already delivered is not bought twice.
     *
     * Refusals to surface: `409 job_not_failed` (still running, or already finished),
     * `409 job_not_retryable` (nothing was recorded about what that run covered, or it named no
     * languages), and `409 job_already_running` — whose `details.jobId` is the run to attach to,
     * exactly as on [pretranslate].
     */
    suspend fun retryMtJob(projectSlug: String, jobId: String): String =
        jsonRequest<JobCreatedResponse>(
            "POST",
            "/projects/${segment(projectSlug)}/mt/jobs/${segment(jobId)}/retry",
        ).jobId

    /**
     * Recent machine-translation runs. The actor is absent for translators and viewers.
     *
     * @param limit 1..100, refused rather than clamped outside that.
     * @param after the previous page's [MtJobsDto.nextCursor], which is null on the last page.
     */
    suspend fun mtJobs(
        projectSlug: String,
        limit: Int = 25,
        after: String? = null,
    ): MtJobsDto = jsonRequest(
        "GET",
        "/projects/${segment(projectSlug)}/mt/jobs" +
            query("limit" to limit.toString(), "after" to after),
    )

    /** One key in every language — what the permalink page renders. */
    suspend fun keyDetail(projectSlug: String, keyId: String): KeyDetailDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/keys/${segment(keyId)}")

    /**
     * Every file format, with what it carries and what it loses.
     *
     * Public and unauthenticated: it is the page a prospect reads before signing up, and putting the
     * answer behind a login is how you lose the team that has been burned before.
     */
    suspend fun formats(): List<FormatDto> = jsonRequest("GET", "/formats")

    /** Every QA check, with this project's opinion of it. Readable by everyone in the project. */
    suspend fun qaRules(projectSlug: String): QaRulesResponse =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/qa/settings")

    /** Owners and admins: a check nobody can approve past is a release decision. */
    /**
     * Sets a check's severity for the project, or for one language when [locale] is given.
     *
     * A language's row wins outright over the project's rather than merging with it, so this is a
     * complete answer for whichever level it is addressed to.
     */
    suspend fun updateQaRule(
        projectSlug: String,
        check: QaCheck,
        enabled: Boolean,
        severity: QaSeverity?,
        locale: String? = null,
    ): QaRuleDto = jsonRequest(
        "PUT",
        "/projects/${segment(projectSlug)}/qa/settings/${segment(check.name)}",
        UpdateQaRuleRequest(enabled = enabled, severity = severity, locale = locale),
    )

    /**
     * Returns one language to whatever the project says about this check.
     *
     * Not the same as writing an override that agrees: a row that matches the project is still a
     * row, and it stops following the project the next time somebody changes it.
     */
    suspend fun clearQaRuleOverride(projectSlug: String, check: QaCheck, locale: String) {
        unitRequest(
            "DELETE",
            "/projects/${segment(projectSlug)}/qa/settings/${segment(check.name)}/locales/${segment(locale)}",
        )
    }

    /** Strings exempted from a check, and why. */
    suspend fun qaIgnores(projectSlug: String): QaIgnoresDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/qa/ignores")

    /** Exempts one string. A blank reason is refused by the server, not defaulted away. */
    suspend fun addQaIgnore(projectSlug: String, request: CreateQaIgnoreRequest) {
        unitRequest("POST", "/projects/${segment(projectSlug)}/qa/ignores", request)
    }

    /**
     * Exempts many strings from one check, for one reason, or writes none of them.
     *
     * Returns how many rows the server actually wrote, which is not always what was sent: repeats
     * collapse against the unique index, so a caller reporting "exempted 340" from its own request
     * length would sometimes be overstating it.
     */
    suspend fun addQaIgnores(projectSlug: String, request: CreateQaIgnoresRequest): QaIgnoresCreatedDto =
        jsonRequest("POST", "/projects/${segment(projectSlug)}/qa/ignores/bulk", request)

    suspend fun removeQaIgnore(projectSlug: String, id: String) {
        unitRequest("DELETE", "/projects/${segment(projectSlug)}/qa/ignores/${segment(id)}")
    }

    suspend fun mtJob(projectSlug: String, jobId: String): MtJobDto =
        jsonRequest("GET", "/projects/${segment(projectSlug)}/mt/jobs/${segment(jobId)}")

    fun pollJob(
        projectSlug: String,
        jobId: String,
        intervalMillis: Long = 1_000,
    ): Flow<MtJobDto> = flow {
        require(intervalMillis > 0) { "Polling interval must be greater than zero." }
        do {
            val job = mtJob(projectSlug, jobId)
            emit(job)
            if (job.state == MtJobState.RUNNING) delay(intervalMillis)
        } while (job.state == MtJobState.RUNNING)
    }

    // Added by F6 — the archive route had no wrapper, so the one route in the product that answers
    // "can I leave" was reachable only by typing the URL. A0's pass covered the MT and QA families.

    /**
     * Everything this project holds, in one archive.
     *
     * Strings in their own formats, the memory as TMX, the glossary as CSV, and the comments and
     * history as JSON. **People who have been burned ask for the exit before they sign**, and the
     * honest answer to "can I leave" is a file they can load into a competitor — which is worth
     * nothing at all while no screen in the product offers it.
     *
     * Distinct from [exportBundle], which is the current strings for a chosen locale set. This is
     * the whole record, including the comments explaining why a string reads the way it does.
     */
    suspend fun exportEverything(projectSlug: String): Blob =
        blobRequest("GET", "/projects/${segment(projectSlug)}/export/all", ZIP_CONTENT_TYPE)

}

internal fun providerUpdateBody(
    request: UpdateProviderSettingsRequest,
    options: JsonObject?,
    clearBaseUrl: Boolean = false,
    clearModel: Boolean = false,
): String {
    require(!clearBaseUrl || request.baseUrl == null) {
        "baseUrl cannot be set and cleared in the same provider update."
    }
    require(!clearModel || request.model == null) {
        "model cannot be set and cleared in the same provider update."
    }
    val fields = API_JSON.encodeToJsonElement(request).jsonObject.toMutableMap()
    if (clearBaseUrl) fields["baseUrl"] = JsonNull
    if (clearModel) fields["model"] = JsonNull
    if (options != null) fields["options"] = options
    return API_JSON.encodeToString(JsonObject(fields))
}

@kotlinx.serialization.Serializable
private class EmptyBody

/** The most key ids one coverage request carries on its URL; see [ApiClient.keyCoverage]. */
internal const val COVERAGE_KEYS_PER_REQUEST = 40

/** [keyIds] cut into request-sized runs, order preserved, none empty. */
internal fun coverageBatches(keyIds: List<String>, size: Int = COVERAGE_KEYS_PER_REQUEST): List<List<String>> =
    if (keyIds.isEmpty()) emptyList() else keyIds.chunked(size)
